// this file added by Bearer Web Developer
import React, { useEffect } from "react";
import { Button, CircularProgress, Dialog } from "@mui/material";
import styles from './imagePopup.module.scss';
import { fetchDownloadUrl } from "../../../../../../api/bearer-api";
import { useThemeMode } from "../../../../../../states/contexts/theme";
interface Props {
    url: string
    open: boolean
    handleClose: () => void
}
const ImagePopup: React.FC<Props> = ({ url, open, handleClose }) => {

    const [preview, setPreview] = React.useState({ loading: true, value: '' });
    useEffect(() => {
        (async () => {
            try {
                const result = await fetchDownloadUrl(url);
                if (result) {
                    setPreview({ loading: false, value: result });
                }
            } catch (error) {
                setPreview(prev => ({ ...prev, loading: false }));
            }
        })();
    }, [url]);
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <Dialog open={open} onClose={handleClose}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: "10px",
                        backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
                    },
                    classes: { root: styles.root }
                },
            }}
            classes={{ paper: styles.paper_dialog, root: styles.root_dialog }}>
            <section className={styles.root} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                <header>
                    <h4>Verification Photo</h4>
                    <Button className={styles.cancel} onClick={handleClose} classes={{ root: styles.root_button }}><img src="/cancel.png" alt="back" /></Button>
                </header>
                {preview?.loading ?
                    <div className={styles.loading}><CircularProgress /></div> :
                    <div className={styles.image}>
                        <img src={preview?.value} height={353} />
                    </div>
                }
            </section>
        </Dialog>
    )
}
export default ImagePopup;